document.addEventListener('DOMContentLoaded', function () {
  console.log("✅ custom.js is loaded");

  setTimeout(function () {
    const form = document.querySelector('form.product-form');
    const qtyInput = document.querySelector('input.quantity_input');


    if (!form || !qtyInput) {
      console.log("❌ Form or quantity input not found");
      return;
    }

    const minQty = parseInt(qtyInput.dataset.minQty, 10) || 1;
    console.log("Metafield value from data attribute:", minQty);

    // Do NOT override the input value—Liquid already sets it
    // Just enforce the rule on submit
    form.addEventListener('submit', function (e) {
      const selectedQty = parseInt(qtyInput.value, 10);
      if (selectedQty < minQty) {
        e.preventDefault();
        alert(`Minimum order quantity is ${minQty}. Please adjust before checking out.`);
        qtyInput.focus();
      }
    });
  }, 1000);
});

/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
